import { useCallback } from "react";

export function useTranslation() {
  const translateText = useCallback(async (text: string, src: string, tgt: string): Promise<string> => {
    if (!text.trim()) return "";
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${src === "auto" ? "auto" : src}&tl=${tgt}&dt=t&q=${encodeURIComponent(text)}`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      return data[0].map((item: any) => item[0]).join("");
    } catch (err) {
      console.error("Translation error:", err);
      return text;
    }
  }, []);

  return { translateText };
}
